import axios from '../../plugins/axios'

export const updatePickupClosingTime = (_, payload) => {
  return axios.put('/settings/pickup-closing-time', payload.data)
}

export const getBusinessSettings = () => {
  return axios.get('/settings')
}
